import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMyFamilies } from "../../lib/api-family";
import { CreateFamilyForm } from "./CreateFamilyForm";

type GuardState = "checking" | "allowed" | "redirect" | "error";

export function CreateFamilyRoute() {
  const [status, setStatus] = useState<GuardState>("checking");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setStatus("checking");
    getMyFamilies()
      .then((families) => {
        if (!cancelled) setStatus(families.length === 0 ? "allowed" : "redirect");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, [attempt]);

  if (status === "checking") {
    return (
      <div className="flex flex-1 items-center justify-center" aria-label="Проверяем семью">
        <div className="h-9 w-9 animate-spin rounded-full border-[3px] border-[#FF7A00] border-t-transparent" />
      </div>
    );
  }

  if (status === "redirect") {
    return <Navigate to="/family" replace />;
  }

  if (status === "error") {
    return (
      <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
        <h1 className="mb-2 text-2xl font-bold tracking-[-0.03em] text-[#171714]">
          Не удалось проверить семью
        </h1>
        <p className="mb-6 text-sm text-[#77776F]">
          Проверьте подключение и попробуйте ещё раз.
        </p>
        <button
          type="button"
          onClick={() => setAttempt((value) => value + 1)}
          className="cursor-pointer rounded-full bg-[#171714] px-7 py-3 text-sm font-semibold text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#171714]"
        >
          Повторить
        </button>
      </div>
    );
  }

  return <CreateFamilyForm />;
}
